<template>
  <div
    class="horizontal-layout page-header-light horizontal-menu 1-column login-bg blank-page blank-page"
    data-open="click"
    data-menu="horizontal-menu"
    data-col="1-column"
  >
    <div class="row">
      <div class="col s12">
        <div class="container">
          <div id="login-page" class="row">
            <div class="col s12 m6 l4 z-depth-4 card-panel border-radius-6 login-card bg-opacity-8">
              <form class="login-form">
                <div class="row">
                  <div class="input-field col s12">
                    <h5 class="ml-4">Sign in</h5>
                  </div>
                </div>
                <div class="row margin">
                  <div class="input-field col s12">
                    <i class="material-icons prefix pt-2">person_outline</i>
                    <input
                      id="username"
                      @keyup="errorMessage=''"
                      v-model="username"
                      name="uname"
                      type="text"
                    />
                    <label for="username" class="center-align">Username</label>
                  </div>
                </div>
                <div class="row margin">
                  <div class="input-field col s12">
                    <i class="material-icons prefix pt-2">lock_outline</i>
                    <input
                      maxlength="15"
                      @keyup="errorMessage=''"
                      id="password"
                      v-model="password"
                      name="password"
                      type="password"
                    />
                    <label for="password">Password</label>
                  </div>
                </div>
                <div class="row mar">
                  <div class="input-field col s12">
                    <!-- @click="$router.push({path: '/app/dashboard'})" -->
                    <span
                      class="error-message text-center"
                      v-if="showSignInErrorMesg"
                    >{{errorMessage}}</span>
                    <button
                      v-loader-button="isLoading"
                      type="submit"
                      name="action"
                      class="btn waves-effect waves-light col s12"
                    >Login</button>
                  </div>
                </div>
                <div class="row">
                  <div class="input-field col s12 m12 l12">
                    <p class="margin right-align medium-small">
                      <a
                        class="pointer"
                        @click="$router.push({path: '/forgot-password'})"
                      >Forgot password ?</a>
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      clientId: "",
      showSignInErrorMesg: false,
      errorMessage: "",
      showPassword: false,
      isLoading: false
    };
  },
  created() {
    if (localStorage.getItem("homecare_admin_auth")) {
      this.$router.push({
        path: "/app/dashboard"
      });
    }
    this.initJs();
    this.clientId = window.uuid();
  },
  methods: {
    initJs() {
      // this.$router.push({path: '/app/dashboard'});
      setTimeout(() => {
        $(".login-form").validate({
          rules: {
            uname: {
              required: true,
              email: true
            },
            password: {
              required: true,
              minlength: 6
            },
            remote: null
          },
          //For custom messages
          messages: {
            uname: {
              required: "Email address is required"
            },

            password: {
              required: "Password is required",
              minlength: "Please enter at least 6 characters"
            }
          },
          errorElement: "div",
          errorPlacement: function(error, element) {
            var placement = $(element).data("error");
            if (placement) {
              $(placement).append(error);
            } else {
              error.insertAfter(element);
            }
          },
          submitHandler: e => {
            $("button").attr("disabled", "disabled");
            setTimeout(() => {
              $("button").removeAttr("disabled");
            }, 500);
            this.onLogin();
            // this.$router.push({ path: "/app/dashboard" });
            return false;
          }
        });
      }, 500);
    },
    onLogin() {
      this.isLoading = true;
      let params = {
        email: this.username,
        password: this.password,
        uuid: this.clientId
      };

      ajax.post(
        Constants.default.APIURL.Login,
        params,
        res => {
          this.isLoading = false;
          this.showSignInErrorMesg = false;
          let data = res.data.user;
          if (data != "") {
            let permissions = [];
            data.permissions.forEach(val => {
              permissions.push(val.permission);
            });
            let userDetails = {
              email: data.email,
              id: data.id,
              first_name: data.first_name,
              short_name: data.short_name,
              mobile_number: data.mobile_number,
              access_token: res.data.auth_token,
              permissions: permissions,
              persona: data.persona
            };
            localStorage.removeItem("homecare_admin_auth");
            sessionStorage.removeItem("homecare_admin_auth");
            localStorage.setItem(
              "homecare_admin_auth",
              JSON.stringify(userDetails)
            );
            if (localStorage.getItem("homecare_admin_fcmtoken")) {
              ajax.put(
                Constants.default.APIURL.UpdateFCMToken,
                {
                  firebase_token: localStorage.getItem(
                    "homecare_admin_fcmtoken"
                  )
                },
                res => {},
                err => {}
              );
            }
            if (userDetails.persona == "superuser") {
              this.$router.push({
                path: "/app/dashboard"
              });
            } else {
              this.$router.push({
                path: "/app/dashboard"
              });
            }
          }
        },
        err => {
          this.isLoading = false;
          this.errorMessage = Vue.errorHandler(err);
          this.showSignInErrorMesg = true;
        }
      );
    },
    resetError() {
      this.errorMessage = "";
      this.showSignInErrorMesg = false;
    },
    onShowPassword() {
      this.showPassword = !this.showPassword;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./../../public/assets/css/pages/login.css";
</style>
